import { useQuery } from "@tanstack/react-query";
import { IAdminGetUserResponse, getUser } from "../clients/admin-client";

export const useUserAccounts = (userId: string) => useQuery<
IAdminGetUserResponse
>(['user', userId], () => getUser(userId), {
cacheTime: 60 * 60 * 1000, // 1 hour
});
